import React, { useState, useEffect, useContext } from 'react';
import { Button, Image, Table, Modal, Form } from 'react-bootstrap';
import '../App.css';
import api from '../utils/api';
import useAuth from '../context/useAuth';
import Notification from '../components/Notification';
import { useLocation, useHistory, withRouter, useParams } from 'react-router-dom';
import queryString from 'query-string';
import { DateRangeContext } from '../context/DateRangeContext';
import { DepositContext } from '../context/DepositContext';



const ReceiptDetails = (props) => {
    console.log(props);
    const { receiptNum } = useParams();
    const { role } = useAuth();
    const [receipt, setReceipt] = useState({});
    const [receipts, setReceipts] = useState([]);
    const [orgDetails, setOrgDetails] = useState({});
    const [memberDetails, setMemberDetails] = useState({});
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [showNotification, setShowNotification] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const location = useLocation();
    const history = useHistory();
    const [amountInWords, setAmountInWords] = useState('');
    const [receiptMemberId, setReceiptMemberId] = useState('');
    const [totalYtdDonation, setTotalYtdDonation] = useState(0.00);

    const { searchCriteria, currentPage } = location.state || {};
    const queryParams = new URLSearchParams(location.search);
    const pagerfm = queryParams.get('pagerfm');
    const pagerds = queryParams.get('pagerds');
    const pagetkt = queryParams.get('pagetkt');
    const daterdr = queryParams.get('daterdr');
    const { page } = queryString.parse(location.search);

    const { dateRange } = useContext(DateRangeContext);
    // for void dialog box
    const [showModal, setShowModal] = useState(false);
    // for email dialog box
    const [show, setShow] = useState(false);
    const [isEmailTriggered, setIsEmailTriggered] = useState(false);
    const [reason, setReason] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { depositData, setDepositData } = useContext(DepositContext);

    const numberToWords = (num) => {
        const belowTwenty = [
            'Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten',
            'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'
        ];
        const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
        const thousand = ['', 'Thousand', 'Million', 'Billion'];

        if (num === 0) return 'Zero';

        const helper = (num) => {
            if (num < 20) {
                return belowTwenty[num] + ' ';
            } else if (num < 100) {
                return tens[Math.floor(num / 10)] + (num % 10 !== 0 ? ' ' + helper(num % 10) : '');
            } else if (num < 1000) {
                return belowTwenty[Math.floor(num / 100)] + ' Hundred' + (num % 100 !== 0 ? ' ' + helper(num % 100) : '');
            } else {
                for (let i = 0; i < thousand.length; i++) {
                    if (num < Math.pow(1000, i + 1)) {
                        return helper(Math.floor(num / Math.pow(1000, i))) + thousand[i] + ' ' + (num % Math.pow(1000, i) !== 0 ? helper(num % Math.pow(1000, i)) : '');
                    }
                }
            }
        };

        return helper(num).trim();
    };

    const convertDollarAmountToWords = (amount) => {
        let [dollars, cents] = amount.toString().split('.');

        if (cents === undefined) {
            cents = '00';
        } else if (cents.length === 1) {
            cents += '0';
        }

        let dollarWords = numberToWords(parseInt(dollars));
        let centWords = parseInt(cents) > 0 ? numberToWords(parseInt(cents)) : '';

        let result = `${dollarWords} Dollar${parseInt(dollars) !== 1 ? 's' : ''}`;

        if (parseInt(cents) > 0) {
            result += ` and ${centWords} Cent${parseInt(cents) !== 1 ? 's' : ''}`;
        }

        return result;
    };


    const getReceipt = () => {
        const path = `/api/receipts/${receiptNum}`;
        api.get(path)
            .then(res => {
                setReceipt(res.data.data);
                setIsLoading(false);
                setAmountInWords(convertDollarAmountToWords(res.data.data.donationAmt));
                setReceiptMemberId(res.data.data.memberId);
            })
            .catch(error => {
                if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                    console.log('User is not authenticated or token expired. Redirecting to login page.');
                    props.history.push('/login');
                } else {
                    if (error.response.status === 404) {
                        console.error('Error fetching receipts:', error);
                        setError("No donation receipt found. Please enter valid receipt number.");
                    }
                    else {
                        setError(error.message);
                        console.error('Error fetching receipts:', error);
                    }
                }
                setIsLoading(false);
            });
    };

    const formatDate = (dateStr) => {
        // Check if dateStr is undefined, null, or an empty string
        if (!dateStr) {
            return ''; // Return an empty string or any default value if dateStr is not valid
        }

        // Split the date string into its components
        const [year, month, day] = dateStr.split('-');

        // Return the formatted date as MM/DD/YYYY
        return `${month}/${day}/${year}`;
    };

    const getOrg = () => {
        const path = '/api/appconfig';
        api.get(path)
            .then(res => {
                setOrgDetails(res.data.data);
                setIsLoading(false);
            })
            .catch(error => {
                if (error.response && error.response.status === 401) {
                    console.log('User is not authenticated or token expired. Redirecting to login page.');
                    props.history.push('/login');
                } else {
                    if (error.response.status === 404) {
                        console.error('Error fetching org details:', error);
                        setError("No organization found. Please contact support.");
                    }
                    else {
                        setError(error.message);
                        console.error('Error fetching organization details:', error);
                    }
                }
                setIsLoading(false);
            });
    };

    const getMemberDetails = () => {
        const path = `/api/members/${receiptMemberId}`;

        api.get(path)
            .then(res => {
                setMemberDetails(res.data.data);
                setIsLoading(false);
            })
            .catch(error => {
                if (error.response && error.response.status === 401) {
                    console.log('User is not authenticated or token expired. Redirecting to login page.');
                    props.history.push('/login');
                } else {
                    if (error.response.status === 404) {
                        console.error('Error fetching member details:', error);
                        setError("No member details found. Please contact support.");
                    }
                    else {
                        setError(error.message);
                        console.error('Error fetching member details:', error);
                    }
                }
                setIsLoading(false);
            });
    };

    const getYTDMemberReceiptsHistory = async () => {
        const year = receipt.receiptDate.split('-')[0];

        const path = `/api/members/${receiptMemberId}/receipts?year=${year}`;
        api.get(path)
            .then(res => {
                setReceipts(res.data.data);
                setTotalYtdDonation(res.data.totalDonation);
                setIsLoading(false);
            })
            .catch(error => {
                if (error.response && error.response.status === 401) {
                    console.log('User is not authenticated or token expired. Redirecting to login page.');
                    props.history.push('/login');
                } else {
                    if (error.response.status === 404) {
                        console.error('Error fetching member receipts history details:', error);
                        setError("No  member receipts history details found. Please contact support.");
                    }
                    else {
                        setError(error.message);
                        console.error('Error fetching member receipts history details:', error);
                    }
                }
                setIsLoading(false);
            });
    };

    useEffect(() => {
        getReceipt();
        getOrg();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [receiptNum, props.history]);

    useEffect(() => {
        if (receiptMemberId) {
            getMemberDetails();
            getYTDMemberReceiptsHistory();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [receiptMemberId]);

    // New useEffect to trigger email if the query parameter exists
    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const triggerEmail = queryParams.get('triggerEmail') === 'true';

        if (triggerEmail && !isEmailTriggered) {
            setShow(true); // Show the modal to confirm email sending
            setIsEmailTriggered(true); // Prevent multiple triggers
        }
    }, [location.search, isEmailTriggered]); // Trigger on location changes and if email has been triggered


    const handleGoBack = () => {
        // Check if coming from CardPayments page
        if (history.location.state && history.location.state.fromCardPayments) {
            history.push({
                pathname: '/cardpayments',
                search: history.location.state.page ? `?page=${history.location.state.page}` : '',
                state: {
                    searchCriteria: history.location.state.searchCriteria || {}
                }
            });
            return; // Exit after handling cardpayments
        }

        // Existing logic
        if (page) {
            if (dateRange) {
                console.log(dateRange);
            }
            history.push(`/receipts?page=${page}`);
        } else {
            if (pagerfm) {
                console.log(receipt.memberId);
                history.push({
                    pathname: `/receiptsForMember/${receipt.memberId}`,
                    search: `?pagerfm=${pagerfm}`,
                    state: { searchCriteria, currentPage }
                });
            } else {
                if (pagerds) {
                    history.push({
                        pathname: `/donationHistory/${receipt.memberId}`,
                        search: `?pagerds=${pagerds}&daterdr=${daterdr}`,
                        state: { searchCriteria, currentPage }
                    });
                } else {
                    if (pagetkt) {
                        if (depositData) {
                            setDepositData({
                                currentPage: 1,
                                checkStart: depositData.checkStart,
                                checkEnd: depositData.checkEnd,
                            });
                        }
                        history.push(`/addNewDepositTicket`);
                    } else {
                        history.push({
                            pathname: '/members',
                            state: { searchCriteria, currentPage }
                        });
                    }
                }
            }
        }
    };

    const handlePrintAll = () => {
        window.print();
    };

    const downloadPDF = async () => {
        try {
            const response = await api.get(`/api/receipts/${receiptNum}/pdf`, { responseType: 'blob' });
            const pdfBlob = response.data;
            const header = await pdfBlob.slice(0, 5).text();
            const trailer = await pdfBlob.slice(-1024).text();
            const contentLength = Number(response.headers['content-length']);
            if (header !== '%PDF-' || !trailer.includes('%%EOF') || (contentLength && contentLength !== pdfBlob.size)) {
                throw new Error('The receipt PDF download is incomplete or invalid.');
            }

            const pdfUrl = window.URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = pdfUrl;
            link.download = `receipts_${receipt.memberId}_${receipt.receiptNum}.pdf`;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.setTimeout(() => window.URL.revokeObjectURL(pdfUrl), 60000);
        } catch (err) {
            console.error('PDF download error:', err);
            window.alert(err.response?.data?.error || err.message);
        }
    };

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);


    const handleEmail = async () => {
        try {
            const response = await api.post(`/api/receipts/${receiptNum}/email`);
            setShowNotification(true);
            setNotificationMessage(response.data.message);
            handleClose();
        } catch (error) {
            setError(error.response?.data?.error || error.message);
            console.error('Error sending receipt email:', error);
        }
    };

    const handleVoid = () => {
        if (reason.trim() === '') {
            setError('Reason is required');
            return;
        }
        setIsSubmitting(true);
        const path = `/api/receipts/${receiptNum}`;
        api.patch(path, {
            status: 'V',
            donationAmt: 0.00,
            reason
        })
            .then(res => {
                console.log('Void Response:', res.data);
                if (res.data.error) {
                    setError(res.data.error);
                } else {
                    setReceipt({ ...receipt, status: 'V', donationAmt: 0.00, description: reason });
                    setShowNotification(true);
                    setNotificationMessage(res.data.msg);
                    // Refresh the YTD history
                    getYTDMemberReceiptsHistory();
                }
                setIsSubmitting(false);
                setShowModal(false);
            })
            .catch(error => {
                setError(error.message);
                console.error('Error voiding receipt:', error);
                setIsSubmitting(false);
            });
    };



    if (isLoading) {
        return <div>Loading...</div>;
    }
    const groupReceiptsInPairs = (receipts) => {
        const grouped = [];
        for (let i = 0; i < receipts.length; i += 2) {
            grouped.push(receipts.slice(i, i + 2));
        }
        return grouped;
    };
    const handleShowModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    return (
        <div>
            {showNotification && (
                <div className="notification-message no-print small-font">
                    <Notification message={notificationMessage} />
                </div>
            )}
            <Button className="btn btn-secondary no-print small-font" style={{ float: "right" }} onClick={handleGoBack}>
                Go Back
            </Button>
            {error && (
                <div className="alert alert-danger" role="alert">
                    Error: {error}
                </div>
            )}
            {!error && (
                <div className="button-group no-print">
                    <Button className="no-print small-font" onClick={handlePrintAll}>Print</Button>
                    <Button className="no-print small-font" onClick={handleShow}>
                        Email
                    </Button>

                    <Modal show={show} onHide={handleClose}>
                        <Modal.Header closeButton>
                            <Modal.Title>Email Confirmation</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {memberDetails.email ? (
                                <>
                                    Are you sure you want to send the receipt details to{' '}
                                    <strong>{memberDetails.email}</strong>?
                                </>
                            ) : (
                                <span className="text-danger">Email can't be sent because the email address is blank.</span>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                                Close
                            </Button>
                            {memberDetails.email && (
                                <Button variant="primary" onClick={handleEmail}>
                                    Confirm
                                </Button>
                            )}
                        </Modal.Footer>
                    </Modal>
                    <Button className="no-print small-font" onClick={downloadPDF}>Download PDF</Button>
                    {(role === 'ops' || role === 'admin') && (
                        <>
                            <Button
                                className="btn btn-secondary m-1 small-font"
                                onClick={() => {
                                    if (receipt.status === 'V') {
                                        window.alert('This receipt has already been voided. You cannot void it again.');
                                    } else {
                                        handleShowModal();
                                    }
                                }}
                            >
                                Void
                            </Button>
                            <Modal show={showModal} onHide={handleCloseModal}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Void Receipt</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <Form>
                                        <Form.Group controlId="reason">
                                            <Form.Label>Reason for Voiding</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={reason}
                                                onChange={(e) => setReason(e.target.value)}
                                                disabled={isSubmitting}
                                                placeholder="Enter the reason"
                                            />
                                        </Form.Group>
                                    </Form>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleCloseModal} disabled={isSubmitting}>
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="primary"
                                        onClick={handleVoid}
                                        disabled={isSubmitting}
                                    >
                                        Submit
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                        </>
                    )}
                </div>
            )}
            <div>
                <div className="button-spacing"></div>  {/* Spacer div */}
                {!error && (
                    <div className="summary-section">
                        <div className="summary-left">
                            <p className="bold-text small-font">{orgDetails.name}</p>
                            <p className="small-font">{orgDetails.address} {orgDetails.address2}</p>
                            <p className="small-font">{orgDetails.city}, {orgDetails.state} {orgDetails.zip}</p>
                            <p className="small-font">Phone: {orgDetails.phone}</p>
                        </div>
                        <div className="summary-center">
                            <div className="image-container">
                                {orgDetails.logoImage ? (
                                    <Image
                                        src={`/${orgDetails.logoImage}`} // Dynamically get the logo path from orgDetails
                                        alt="ORGMS Logo"
                                        fluid
                                        style={{
                                            width: '200px',
                                            height: 'auto',
                                        }}
                                    />
                                ) : (
                                    <p>Organization Logo not available</p>
                                )}
                            </div>
                        </div>
                        <div className="summary-right">
                            <p className="bold-text small-font">Official Donation Receipt</p>
                            <p className="bold-text small-font">Tax ID: {orgDetails.taxId}</p>
                            <p className="bold-text small-font">Receipt Number: {receipt.receiptNum}</p>
                            <p className="bold-text small-font">Date: {formatDate(receipt.receiptDate)}</p>
                            <p className="bold-text small-font">OperatorId: {receipt.operatorId}</p>
                        </div>
                    </div>
                )}
                {!error && (
                    <div className="summary-section">
                        <div className="rsummary-left">
                            <div className="address-block"> {/* Address block with margin */}
                                <p className="bold-text small-font">{receipt.first1} {receipt.middle1} {receipt.last1}</p>
                                <p className="bold-text small-font">{receipt.first2} {receipt.middle2} {receipt.last2}</p>
                                <p className="small-font">{receipt.address}</p>
                                <p className="small-font">{receipt.address2}</p>
                                <p className="small-font">{receipt.city} {receipt.state}, {receipt.country}, {receipt.zip}</p>
                            </div>
                        </div>
                        <div className="rsummary-right">
                            <p className="bold-text small-font">Account Number: {receipt.memberId}</p>
                            <p className="small-font"><b>Amount:</b> ${receipt.donationAmt}</p>
                            <p className="small-font"><b>Amount in Words:</b> {amountInWords}</p>
                            <p className="small-font"><b>Check/CC-Ref#: </b>{receipt.paymentReference}</p>
                            <p className="small-font"><b>For:</b> {receipt.description}</p>
                        </div>
                    </div>
                )}
                {!error && (
                    <p className="bold-text small-font">
                        Note: All donations are Tax Deductible. Tax ID: {orgDetails.taxId}. Thank you for your generosity.
                    </p>
                )}
                {!error && (
                    <hr className="dark-black-hr" />
                )}
                {!error && (
                    <div className="summary-section">
                        <div className="summary-left">
                            <p className="bold-text small-font">{orgDetails.name}</p>
                            <p className="small-font">{orgDetails.address} {orgDetails.address2}</p>
                            <p className="small-font">{orgDetails.city}, {orgDetails.state} {orgDetails.zip}</p>
                            <p className="small-font">Phone: {orgDetails.phone}</p>
                            <p className="small-font">Tax ID: {orgDetails.taxId}</p>
                        </div>
                        <div className="summary-center">
                            <div className="image-container">
                                {orgDetails.qrCodeImage ? (
                                    <Image
                                        src={`/${orgDetails.qrCodeImage}`} // Dynamically get the QR code path from orgDetails
                                        alt="QR Code"
                                        fluid
                                        style={{
                                            width: '120px',
                                            height: 'auto',
                                        }}
                                    />
                                ) : (
                                    <p>QR Code not available</p>
                                )}
                            </div>
                        </div>
                        <div className="summary-right">
                            <p className="bold-text small-font">
                                Donation History for {receipt.receiptDate ? receipt.receiptDate.split('-')[0] : 'Unknown Year'}
                            </p>
                            <p className="bold-text small-font">Account Number: {memberDetails.memberId}</p>
                            <p className="small-font">{memberDetails.first1} {memberDetails.middle1} {memberDetails.last1}</p>
                            <p className="small-font">{memberDetails.first2} {memberDetails.middle2} {memberDetails.last2}</p>
                            <p className="small-font">{memberDetails.address} {memberDetails.address2}, {memberDetails.city}, {memberDetails.state}, {memberDetails.country} {memberDetails.zip}</p>
                        </div>
                    </div>
                )}
                {!error && (
                    receipts.length > 0 ? (
                        <>
                            <p className="small-font">
                                Following are the donations made by you and/or your family member. Should you notice any discrepancy, please let us know.
                                We appreciate your financial support and patronage. Donor did not receive any material benefit for these donations.
                            </p>
                            <div className="receipt-table-container">
                                <Table hover size="sm" className="small-font">
                                    <thead>
                                        <tr>
                                            <th>Receipt No</th>
                                            <th>Date</th>
                                            <th>Check/CC-Ref#</th>
                                            <th>Amount</th>
                                            <th className="dummy-column"></th> {/* Dummy column for spacing */}
                                            <th>Receipt No</th>
                                            <th>Date</th>
                                            <th>Check/CC-Ref#</th>
                                            <th>Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {groupReceiptsInPairs(receipts).map((pair, index) => (
                                            <tr key={index}>
                                                {/* First Receipt */}
                                                {pair[0] ? (
                                                    <>
                                                        <td>{pair[0].receiptNum}</td>
                                                        <td>{formatDate(pair[0].receiptDate)}</td>
                                                        <td>{pair[0].paymentReference}</td>
                                                        <td>${pair[0].donationAmt}</td>
                                                    </>
                                                ) : (
                                                    <>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </>
                                                )}
                                                <td className="dummy-column"></td> {/* Dummy column for spacing */}
                                                {/* Second Receipt */}
                                                {pair[1] ? (
                                                    <>
                                                        <td>{pair[1].receiptNum}</td>
                                                        <td>{formatDate(pair[1].receiptDate)}</td>
                                                        <td>{pair[1].paymentReference}</td>
                                                        <td>${pair[1].donationAmt}</td>
                                                    </>
                                                ) : (
                                                    <>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </>
                                                )}
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                            <p className="small-font">Total Donation amount for the current year: <b>${totalYtdDonation}</b></p>
                        </>
                    ) : (

                        <div className="text-center small-font">
                            {!error && (
                                <div>No member donation receipts history found for the current year.</div>
                            )}
                        </div>
                    )
                )}
            </div>
        </div>
    );
};

export default withRouter(ReceiptDetails);